"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_router_1 = __importDefault(require("vue-router"));
exports.default = {
    install: (Vue, { sentry }) => {
        const originalVueConfigWarnHandler = Vue.config.warnHandler;
        /**
         * Since sentry doesn't track Vue warnings by default, we manually capture warnings.
         * Note: Vue.config.warnHandler is not called in production environment
         */
        Vue.config.warnHandler = (msg, vm, trace) => {
            sentry.captureMessage(`${msg} - ${trace.trim()}`, sentry.Severity.Warning);
            if (typeof originalVueConfigWarnHandler === 'function') {
                originalVueConfigWarnHandler(msg, vm, trace);
            }
        };
        async function handleRouting(navigationPromise) {
            const { isNavigationFailure, NavigationFailureType } = vue_router_1.default;
            // If not redirected by the router naviguation guard
            // https://router.vuejs.org/guide/advanced/navigation-failures.html#detecting-navigation-failures
            // Prevents applicative redirections from being logged to Sentry as errors.
            return navigationPromise.catch((err) => {
                if (!isNavigationFailure(err, NavigationFailureType.redirected)) {
                    sentry.captureException(err);
                }
            });
        }
        Vue.prototype.$sentry = sentry;
        Vue.prototype.$sentry.handleRouting = handleRouting;
    },
};
